import { Controller } from '@hotwired/stimulus'

// #AI: EB (ElectionBuddy) is loaded via Sprockets as a global variable
const EB = window.EB;

export default class extends Controller {
  connect() {
    if (!EB || !EB.Elections) {
      console.error('[WriteInDragController] EB not available');
      return;
    }
    
    const Elections = EB.Elections;
    if (Elections.Results.pageRequiresDragAndDropFeature(document.body)) {
      Elections.Results.initWriteInDrag(this.element)
    }
  }
}
